import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
export const LicenseCategoryFilterKey = {
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
  EXPIRED: 'EXPIRED'
} as const;
export type LicenseCategoryFilterKey = EnumUnion<typeof LicenseCategoryFilterKey>;
export const SoftwareTypeFilterKey = {
  INSTALLED: 'INSTALLED',
  MW_OS: 'MW_OS',
  SCRATCH: 'SCRATCH',
  SAAS: 'SAAS',
  CUSTOM_SAAS: 'CUSTOM_SAAS'
} as const;
export type SoftwareTypeFilterKey = EnumUnion<typeof SoftwareTypeFilterKey>;
export const TabKey = {
  SAAS: SoftwareTypeFilterKey.SAAS,
  INSTALLED: SoftwareTypeFilterKey.INSTALLED,
  MW_OS: SoftwareTypeFilterKey.MW_OS,
  SCRATCH: SoftwareTypeFilterKey.SCRATCH,
  ALL: LicenseCategoryFilterKey.ALL,
  EXPIRED: LicenseCategoryFilterKey.EXPIRED
} as const;
export type TabKey = EnumUnion<typeof TabKey>;
export const SearchSchema = z.object({
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC),
  category: z.nativeEnum(TabKey).default(TabKey.SAAS),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.enum(['NAME']).optional()
});